import React from 'react'
import EditableComponent from './EditableComponent'
import { DropDownList } from '@/components/dropDownList'
import getEnumTranslation from '@/enums/enums'

const VALIDATION_REGEX = {
  TEXT: /.*/,
  NUMBER: /^\d*$/
}
class InfoContentEditable extends EditableComponent {
  handleInputChange (value, regex) {
    if (regex.test(value) === true) { this.props.onChange(value) }
  }
  renderReadOnlyText (value) {
    return (<input
      className='form-control'
      type='text'
      disabled
      value={value || this.props.value} />)
  }
  renderInput (validationRegex) {
    return (
      <input
        className='form-control'
        type='text'
        disabled={this.isEdited() === false || this.props.disabled}
        value={this.props.value}
        onChange={e => this.handleInputChange(e.target.value, validationRegex)}
        onKeyDown={e => { if (e.keyCode === 13) this.toggleEditing() }} />
    )
  }
  renderEnum () {
    const { localize, enumName, value, disabled } = this.props
    if (this.isEdited() === true && !disabled) {
      const { enumValues } = this.props
      const data = enumValues.map(x => ({ text: getEnumTranslation({ localize, enumName, value: x }), value: x }))

      return (<DropDownList
        data={data}
        onChange={({ value }) => this.props.onChange(value)}
        value={value}
        textField='text'
        valueField='value' />)
    } else {
      return this.renderReadOnlyText(getEnumTranslation({ localize, enumName, value }))
    }
  }
  renderControl () {
    switch (this.props.type) {
      case 'text': return this.renderInput(VALIDATION_REGEX.TEXT)
      case 'number': return this.renderInput(VALIDATION_REGEX.NUMBER)
      case 'enum': return this.renderEnum()
      default: return this.renderReadOnlyText(this.props.localize('Common.NotAvailable'))
    }
  }
}

export default InfoContentEditable



// WEBPACK FOOTER //
// ./src/components/Editors/InfoContentEditable.js